<template>
  <div id="box">
    <div class="box_bg"></div>

    <div class="box_logo" @click="DigitalCertificate()">
      <img :src="httplogo" style="width: 68px;height: 78px;margin-right: 22px" />
      <div :style="{ fontSize: fontSize + 'px' }" >{{ configdata.projectname }}</div>
    </div>
    



    <div class="box_login">
      <div class="box_login_title">欢迎登录</div>

      <div class="box_login_form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入注册手机号码">
              <i slot="prefix" class="el-icon-user"></i>
            </el-input>
          </el-form-item>

          <el-form-item prop="name" >
            <el-input v-model="ruleForm.password" placeholder="请输入密码" show-password>
              <i slot="prefix" class="el-icon-lock"></i>
            </el-input>
          </el-form-item>


          <el-form-item>
            <el-button style="background: #2882FE;border-color:#2882FE ;" class="box_login_button" type="primary" @click="submitForm('ruleForm')">立即登录</el-button>
          </el-form-item>
        </el-form>

        <div class="box_tiaozhuan">
          <div style="width:50%;color: #2882FE;text-align: left " @click="modify()">忘记密码？</div>
          <div style="width:50%;text-align:right ">没有账号<span style="color: #2882FE;" @click="register()">点击注册</span></div>
        </div>
      </div>
    </div>

    <div class="box_foot">Copyright © 2010-2023 华道艾腾 ALL Rights Reserved 版权所有</div>

  </div>
</template>

<script>
import {sendloginemail, conf_list, userlogin, sms_sendSms, Company_getInfo} from "@/api/manage"; // 接口
import Footer from "@/components/footer";
import Header from "@/components/heard";
import {setToken} from "@/utils/auth";

export default {
  name: "paytest",
  components: {Footer , Header},
  props: {},
  data() {
    return {
      fontSize: 26, // 默认字体大小:
      httplogo:'',
      show: true,
      codetxt: '获取邮箱验证码',
      current: ["app"],
      configdata: {},
      projectname: "",
      billstatus: 0,
      company: "",
      drawer: 1,
      endtime: null,
      id: "",
      page: 1,
      pagesize: 10,
      service: "all",
      starttime: null,
      status: 0,
      yscode: "",
      codestate: 100,
      Index: 0,
      email: "",
      imgurlas: "",
      sIndexs: 1,
      count: "",
      ruleForm: {
        username: "",
        password: "",
      },
      rules: {
        name: [
          {required: true, message: '请输入注册手机号！', trigger: 'blur'},
          {min: 11, message: '请检查手机号位数是否正确！', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入注册密码', trigger: 'blur'},
        ],
      }
    };
  },
  created() {
    this.Index = localStorage.getItem('Index')
    this.setFontSize(); // 组件创建时设置字体大小
    window.addEventListener('resize', this.setFontSize); // 监听窗口大小变化
    this.httplogo = "/imgs/" + window.location.hostname + "/logo.png"
    conf_list({}).then((response) => {
      var obj = response.data;
      obj = JSON.stringify(obj);
      localStorage.setItem('configdata', obj)
      this.configdata = response.data
    });
  },
  destroyed() {
    window.removeEventListener('resize', this.setFontSize); // 移除监听器
  },
  methods: {
    setFontSize() {
      const baseFontSize = 20; // 基准字体大小
      const maxFontSize = 28; // 最大字体大小
      const minFontSize = 25; // 最小字体大小
      const screenWidth = window.innerWidth; // 获取屏幕宽度
      const widthRate = screenWidth / 1920; // 宽度缩放比率（假设1920px设计稿宽度）

      this.fontSize = Math.min(maxFontSize, Math.max(minFontSize, baseFontSize * widthRate));
    },
    modify(){
      this.$router.push("/modify");
    },
    DigitalCertificate() {
      this.$router.push("/");
    },
    register() {
      this.$router.push("/register");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          userlogin({
            username: this.ruleForm.name,
            password: this.ruleForm.password,
          }).then((response) => {
            if(response.code == 200){
              localStorage.setItem('setToken', response.token)
              Company_getInfo({}).then(response => {
                var obj = response.user;
                obj = JSON.stringify(obj);
                localStorage.setItem('companyinfo', obj)
                // this.$router.go(-1);
                if( this.Index == 1){
                  this.$router.push("/index")
                }else if( this.Index == 2){
                  this.$router.push("/seal/index")
                }else if( this.Index == 8){
                  this.$router.push("/cost/index");
                }else if( this.Index == 6){
                  this.$router.push("/cost/check");//seal
                }else if( this.Index == 3){
                  this.$router.push("/orderlist");
                }else{
                  this.$router.push("/")
                }
                // this.$router.push("/index");
                this.$message({
                  message: '登录成功！',
                  type: 'success'
                });
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
@import "./payTest.css";

b {
  color: #333;
}

#box {
  background-image: url("../../assets/login_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}

#ok .ant-form-item-label label::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/**/
.login {
  display: flex;
  flex-direction: column;
  width: 500px;
  overflow: hidden;
  position: fixed;
  left: 50%;
  top: 30%;
  margin-left: -250px;
  z-index: 999;
}

.login_title{
  display: block;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 50px;
  font-weight: bold;
  text-align: center;
  font-family: cursive;
}


/*box_logo*/
.box_logo{
  display: flex;
  flex-direction: row;
  width:100%;
  height: 80px;
  font-weight: bold;
  line-height: 80px;
  padding: 0 10%;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 55px;
  right: 0;
  z-index: 9;
}



/*box_login*/
.box_login{
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 100vh;
  background: rgba(255,255,255,0.8);
  padding: 15% 0;
  box-sizing: border-box;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
}


.box_login_title {
  display: block;
  color:#2882FE;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
}

.box_login_form{
  display: flex;
  flex-direction: column;
  width: 70%;
  height: 100%;
  margin: 0 auto;
}


.box_login_button{
  display: block;
  width: 100%;
  color: #fff;
  background: #2882FE ;
}


.box_tiaozhuan{
  display: flex;
  flex-direction: row;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  cursor: pointer;
}




/*box_foot*/
.box_foot{
  display: block;
  width:70%;
  font-size: 14px;
  color: #666666;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 29px;
  right: 0;
  z-index: 9;
}


</style>
